import { Input, CustomDateTime, CustomEditor, CustomSelect, CustomTextarea, CustomTextInputSuggestion,CustomDatePicker,CustomTimePicker, CustomKeyboardPicker, TimePickerInput, ScoreCardInput, AsyncSelectInput, CustomInputAsTextarea } from '@/imports-files/components/formik-control';
import { AutosuggestInput } from './autosuggest-input';


export function FormikControl(props)
{
  const {control, ...rest} = props
  switch (control)
  {
    case "input":
      return <Input {...rest} />;
    case "ScoreCardInput":
      return <ScoreCardInput {...rest} />  
    case "select":
        return <CustomSelect {...rest}/>;
    case "customtextarea":
          return <CustomTextarea {...rest} />;
    case "customDateTime":
        return <CustomDateTime {...rest}/>;
    case "customDatePicker":
          return <CustomDatePicker {...rest}/>;
    case "customTimePicker":
            return <CustomTimePicker {...rest}/>;
    case "customKeyboardPicker":
    return <CustomKeyboardPicker {...rest}/>;
    case "autosuggestInput":
        return  <AutosuggestInput {...rest} />;
    case "customEditor":
        return <CustomEditor {...rest} />;
    case "autocompleteInput":
        return <CustomTextInputSuggestion {...rest}/>;

    case "autocompleteInputAsTextarea":
        return <CustomInputAsTextarea {...rest}/>;

    case "timeinput":
      return <TimePickerInput {...rest}/>
    case "asyncSelect":
        return <AsyncSelectInput {...rest}/>;
    default: return null;
  }
}
